import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
import { MenuStylingModel } from '../menu/menu-styling.model';
export class ToolbarStylingModel extends CoreStylingModel {
/**
 * Styling for md-toolbar
 */
toolbar?: {
    /**
     * Classes for toolbar section
     */
    class?: string;
    /**
     * Dynamic classes for toolbar section
     */
    dynamicClass?: any;
    /**
     * Styling for info section
     */
    info?: {
      /**
       * Classes for info section
       */
      class?: string;
      /**
       * Dynamic classes for info section
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for info icon
       */
      icon?: IconStylingModel;
    };
    /**
     * Styling for content section
     */
    content?: {
      /**
       * Classes for content section
       */
      class?: string;
      /**
       * Dynamic classes for content section
       */
      dynamicClass?: any;
      /**
       * StylingModel for title
       */
      title?: StylingModel;
      /**
       * StylingModel for template
       */
      template?: StylingModel;
    };
    /**
     * Styling for actions section
     */
    actions?: {
      /**
       * Classes for actions section
       */
      class?: string;
      /**
       * Dynamic classes for actions section
       */
      dynamicClass?: any;
      /**
       * MenuStylingModel for menu section
       */
      menu?: MenuStylingModel;
    };
    /**
     * Styling for maximizing section
     */
    maximizing?: {
      /**
       * Classes for maximizing section
       */
      class?: string;
      /**
       * Dynamic classes for maximizing section
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for minimize icon
       */
      minimizeIcon?: IconStylingModel;
      /**
       * IconStylingModel for maximize icon
       */
      maximizeIcon?: IconStylingModel;
    };
    /**
     * Styling for expandable section
     */
    expandable?: {
      /**
       * Classes for expandable section
       */
      class?: string;
      /**
       * Dynamic classes for expandable section
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for expandable icon
       */
      icon?: IconStylingModel;
    };
    /**
     * Styling for help section
     */
    help?: {
      /**
       * Classes for help section
       */
      class?: string;
      /**
       * Dynamic classes for help section
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for help icon
       */
      icon?: IconStylingModel;
    };
    /**
     * Styling for close section
     */
    close?: {
      /**
       * Classes for close section
       */
      class?: string;
      /**
       * Dynamic classes for close section
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for close icon
       */
      icon?: IconStylingModel;
    };
  };
/**
 * It is the constructor for the ToolbarStylingModel component. It takes the values to create the ToolbarStylingModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ToolbarStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for md-toolbar
 * @type {?}
 */
ToolbarStylingModel.prototype.toolbar;
}

